export default {
  navbar: {
    homePage: 'หน้าหลักนักลงทุนสัมพันธ์',
    companyInfo: 'ข้อมูลบริษัท',
    AboutOrigin: "เกี่ยวกับออริจิ้น",
    History: "ความเป็นมาของออริจิ้น",
    ChairmanMessage: "สารจากประธานกรรมการบริษัท",
    CEOMessage: "สารจากประธานเจ้าหน้าที่บริหาร",
    OrgChart: "โครงสร้างองค์กร",
    GroupStructure: "โครงสร้างกลุ่มบริษัท",
    ManagementStructure: "โครงสร้างการจัดการ",
    Awards: "รางวัลที่ได้รับ",
    CorporateGovernance: "การกำกับดูแลกิจการที่ดี",
    Sustainability: "การขับเคลื่อนธุรกิจเพื่อความยั่งยืน",

    FinancialInfo: "ข้อมูลทางการเงิน",
    KeyInfo: "ข้อมูลสำคัญทางการเงิน",
    Statements: "งบการเงิน",
    MDNA: "คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ",

    StockPriceInfo: "ข้อมูลราคาหลักทรัพย์",
    StockPrice: "ราคาหลักทรัพย์",
    HistoricalPrice: "ราคาหลักทรัพย์ย้อนหลัง",

    ShareholderInfo: "ข้อมูลผู้ถือหุ้น",
    BasicInfo: "ข้อมูลพื้นฐาน",
    MajorShareholders: "รายชื่อผู้ถือหุ้นใหญ่",
    Dividend: "การจ่ายเงินปันผล",
    Meeting: "การประชุมผู้ถือหุ้น",
    Subscription: "ORI-แจ้งสิทธิและรายละเอียดการจองซื้อหุ้นสามัญเพิ่มทุน",
    WarrantInfo: "ข้อมูลสำหรับผู้ถือใบสำคัญแสดงสิทธิ",

    DebtInfo: "ข้อมูลตราสารหนี้",
    CreditRating: "อันดับความน่าเชื่อถือ",
    BillExchange: "ข้อมูลผู้ค้าหลักทรัพย์ (ตั๋วแลกเงิน)",

    NewsCenter: "ศูนย์รวมข่าวสาร",
    SETNews: "ข่าวแจ้งตลาดหลักทรัพย์",
    Press: "ข่าวแจ้งสื่อมวลชน",
    PrintNews: "ข่าวจากสื่อสิ่งพิมพ์",
    EAd: "โฆษณาทางอิเล็กทรอนิกส์",
    Calendar: "ปฏิทินนักลงทุนสัมพันธ์",

    PublishedDocs: "เอกสารเผยแพร่",
    OneReport: "56-1 One Report",
    Annual: "รายงานประจำปี",
    SustainabilityReport: "รายงานความยั่งยืน",
    Form561: "แบบฟอร์ม 56-1",

    Presentation: "กิจกรรมเอกสารนำเสนอ",

    AnalystInfo: "ข้อมูลนักวิเคราะห์",
    ContactAnalyst: "ติดต่อนักวิเคราะห์",
    SecuritiesAnalysis: "บทวิเคราะห์หลักทรัพย์",

    ContactInfo: "สอบถามข้อมูล",
    ContactIR: "ติดต่อนักลงทุนสัมพันธ์",
    SubscribeEmail: "รับอีเมลข่าวสาร",

    // เพิ่มตามเมนูอื่น ๆ
  },
  home: {
    stockSymbol: 'ชื่อย่อหุ้น',
    updated: 'อัปเดตล่าสุด',
    changePercent: 'เปลี่ยนแปลง (%)',
    tradingVolume: 'ปริมาณซื้อขาย (หุ้น)',
    priceRange: 'ช่วงราคาระหว่างวัน',
    stockPriceBtn: 'ราคาหลักทรัพย์',
    factSheetBtn: 'Fact Sheet'
  },
  homeAbout: {
    heading: 'นักลงทุนสัมพันธ์',
    welcome: 'ยินดีต้อนรับสู่ หน้าหลักนักลงทุนสัมพันธ์',
    description1: 'บริษัท ออริจิ้น พร็อพเพอร์ตี้ จำกัด (มหาชน) ก่อตั้งขึ้นใน พ.ศ. 2552 เพื่อประกอบธุรกิจพัฒนาอสังหาริมทรัพย์',
    description2: 'โดยทางบริษัทฯ มุ่งพัฒนาอสังหาริมทรัพย์ประเภทคอนโดมิเนียมบนพื้นที่ที่ให้ความสะดวกในการเดินทางอันได้แก่ทำเล',
    description3: 'ตามแนวสถานีขนส่งมวลชนระบบรางในเขตกรุงเทพมหานครและ ปริมณฑล และทำเลใกล้ทางด่วน เป็นต้น'
  },
  growthHistory: {
    title: 'ประวัติการเติบโตของ ORI',
    netProfit: 'กำไรสุทธิ',
    totalIncome: 'รายได้'
  },
  FinancialInfoHome: {
    sectionTitle: 'ข้อมูลสำคัญทางการเงิน',
    MillionBaht: 'ล้านบาท',
    incomeTitle: 'รายได้',
    profitTitle: 'กำไร',
    presaleTitle: 'Presale',
    backlogTitle: 'Backlog',
    quarterLabel: 'รายไตรมาส',
    yearlyLabel: 'รายปีสะสม',
  },
  latestDocuments: {
    sectionTitle: 'เอกสารล่าสุด',
    year: 'ปี',
    financialStatement: 'งบการเงินไตรมาสที่',
    analysisTitle: 'คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ',
    download: 'ดาวน์โหลด'
  },
  printMediaNews: {
    printNews: 'ข่าวสื่อสิ่งพิมพ์',
    setNews: 'ข่าวแจ้งตลาดหลักทรัพย์ฯ',
    viewAll: 'ดูทั้งหมด',
    readMore: 'อ่านเพิ่มเติม'
  },
  contactInvestorRelations: {
    sectionTitle: 'ติดต่อนักลงทุนสัมพันธ์',
    phone: 'โทรศัพท์ :',
    fax: 'โทรสาร : ',
    email: 'อีเมล : ',
    subscribeTitle: 'สมัครติดตามข่าวสาร',
    subscribeDescription: 'ท่านสามารถลงทะเบียนเพื่อรับข่าวสารอิเล็คทรอนิคส์ เราจะส่งข่าวสารให้ท่านทางอีเมลเมื่อมีข่าวสารทางบริษัทประกาศผ่านเว็บไซต์',
    subscribeButton: 'สมัครรับข่าวสาร'
  },
  footer: {
    contactTitle: 'ติดต่อนักลงทุนสัมพันธ์',
    phone: 'โทรศัพท์ : 081-1311064',
    fax: 'โทรสาร : 02-3988066',
    email: 'อีเมล : ir@origin.co.th',
    subscribeTitle: 'สมัครติดตามข่าวสาร',
    subscribeDesc: 'ท่านสามารถลงทะเบียนเพื่อรับข่าวสารอิเล็คทรอนิคส์ เราจะส่งข่าวสารให้ท่านทางอีเมลเมื่อมีข่าวสารทางบริษัทประกาศผ่านเว็บไซต์',
    subscribeButton: 'สมัครรับข่าวสาร',
    irHomeTitle: 'หน้าหลักนักลงทุนสัมพันธ์',
    menu: {
      financial: 'ข้อมูลทางการเงิน',
      stock: 'ข้อมูลราคาหลักทรัพย์',
      shareholder: 'ข้อมูลผู้ถือหุ้น',
      warrant: 'ข้อมูลสำหรับผู้ถือใบสำคัญแสดงสิทธิ',
      debt: 'ข้อมูลตราสารหนี้',
      calendar: 'ปฏิทินนักลงทุนสัมพันธ์',
      news: 'ห้องข่าว',
      activity: 'กิจกรรมและเอกสารนำเสนอ',
      publish: 'เอกสารเผยแพร่',
      analyst: 'ข้อมูลนักวิเคราะห์',
    },
    copyright: 'COPYRIGHT © 2019 , ORIGIN PROPERTY PUBLIC CO.,LTD ALL RIGHTS RESERVED.'
  },
  BasicInfoTabMenu: {
    info: "ข้อมูลพื้นฐาน",
    majorShareholders: "รายชื่อผู้ถือหุ้นรายใหญ่",
    dividendPayment: "การจ่ายเงินปันผล",
    shareholderMeeting: "การประชุมผู้ถือหุ้น",
    shareSubscription: "ORI - แจ้งสิทธิและรายละเอียดการจองซื้อหุ้นสามัญเพิ่มทุน"
  },
  basicInformation: {
    pageTitle: 'ข้อมูลพื้นฐาน',
    breadcrumbHome: 'หน้าหลักนักลงทุนสัมพันธ์',
    breadcrumbShareholder: 'ข้อมูลผู้ถือหุ้น',

    sectionHeader: 'ข้อมูลทั่วไปของบริษัท',
    companyName: 'ชื่อบริษัท',
    companyNameValue: 'บริษัท ออริจิ้น พร็อพเพอร์ตี้ จำกัด (มหาชน) (“ บริษัทฯ ”)',

    stockSymbol: 'ชื่อย่อหลักทรัพย์',
    stockSymbolValue: 'ORI',

    businessType: 'ประเภทธุรกิจ',
    businessTypeValue: 'ประกอบธุรกิจพัฒนาอสังหาริมทรัพย์',

    companyRegistration: 'เลขทะเบียนบริษัท',
    companyRegistrationValue: '0107557000381',

    registeredShares: 'จำนวนหุ้นจดทะเบียน',
    registeredSharesValue: 'หุ้นสามัญ 2,452,862,453 หุ้น ณ วันที่ 31 ธันวาคม 2563',

    registeredCapital: 'ทุนจดทะเบียน',
    registeredCapitalValue: '1,545,776,222.50 บาท ณ วันที่ 31 ธันวาคม 2563',

    paidUpCapital: 'ทุนจดทะเบียนเรียกชำระแล้ว',
    paidUpCapitalValue: '1,226,431,226.50',

    shareParValue: 'มูลค่าหุ้น',
    shareParValueValue: 'หุ้นละ 0.50 บาท',

    headOffice: 'ที่ตั้งสำนักงานใหญ่',
    headOfficeValue: 'เลขที่ 496 หมู่ที่ 9 ตำบลสำโรงเหนือ อำเภอเมืองสมุทรปราการ จังหวัดสมุทรปราการ 10270',

    phone: 'โทรศัพท์',
    phoneValue: '02 030 0000',

    fax: 'โทรสาร',
    faxValue: '02 398 8066',

    contactAddress: 'ที่อยู่สำหรับติดต่อ',
    contactAddressValue: 'ชั้น 20 อาคารภิรัชทาวเวอร์ แอท ไบเทค เลขที่ 4345 ถนนสุขุมวิท แขวงบางนา เขตบางนา กรุงเทพมหานคร 10260',

    website: 'เว็บไซต์บริษัท',
    websiteValue: 'https://origin.co.th/',
  },
  listShareholderMajor: {
    pageTitle: 'รายชื่อผู้ถือหุ้นรายใหญ่',
    breadcrumbHome: 'หน้าหลักนักลงทุนสัมพันธ์',
    breadcrumbShareholder: 'ข้อมูลผู้ถือหุ้น',

    chartTitle: 'รายชื่อผู้ถือหุ้นรายใหญ่',
    chartAsOf: 'ณ วันที่ 15 มีนาคม 2567',
    tableAsOf: 'ณ วันที่ 30 กันยายน 2567',

    tableHeaderRank: 'ลำดับ',
    tableHeaderName: 'รายชื่อผู้ถือหุ้น',
    tableHeaderShares: 'จำนวนหุ้น (หุ้น)',
    tableHeaderPercentage: '% (หุ้น)',
  },
  dividendPayment: {
    pageTitle: 'การจ่ายเงินปันผล',
    breadcrumbHome: 'หน้าหลักนักลงทุนสัมพันธ์',
    breadcrumbShareholder: 'ข้อมูลผู้ถือหุ้น',
    breadcrumbCurrent: 'การจ่ายเงินปันผล',

    description: 'บริษัทมีนโยบายการจ่ายเงินปันผลให้แก่ผู้ถือหุ้นปีละ 2 ครั้ง ในอัตรารวมแล้วไม่น้อยกว่าร้อยละ 40 ของกำไรสำหรับปีของสุทธิตามงบการเงินได้นิติบุคคล และหลังหักสำรองต่างๆ ทุกประเภทที่กฎหมายและบริษัทฯ กำหนดไว้ในแต่ละปี ทั้งนี้ คณะกรรมการบริษัทฯ จะพิจารณาการจ่ายเงินปันผลโดยคำนึงถึงปัจจัยต่างๆ เพื่อผลประโยชน์ต่อผู้ถือหุ้นเป็นหลัก เช่น ผลการดำเนินงานและฐานะทางการเงินของบริษัทฯ การสำรองเงินไว้เพื่อลงทุนในอนาคต การสำรองเงินไว้เพื่อจ่ายชำระคืนเงินกู้ยืม หรือเป็นเงินทุนหมุนเวียนภายในบริษัทฯ และการจ่ายเงินปันผลนั้นไม่มีผลกระทบต่อการดำเนินงานปกติของบริษัทฯ อย่างมีนัยสำคัญ ตามที่คณะกรรมการบริษัทฯ พิจารณาเห็นสมควรหรือเหมาะสม',

    tableHeaderDecisionDate: 'วันที่กรรมการมีมติ',
    tableHeaderExDividendDate: 'วันที่ขึ้นเครื่องหมาย',
    tableHeaderPaymentDate: 'วันที่จ่ายเงินปันผล',
    tableHeaderType: 'ประเภทเงินปันผล',
    tableHeaderPerShare: 'เงินปันผลต่อหุ้น (บาท)',
    tableHeaderPeriod: 'รอบผลประกอบการ',

    cashDividend: 'เงินปันผล',
    stockDividend: 'หุ้นปันผล',
  },
  shareholderMeetings: {
    shareholderMeeting: "การประชุมผู้ถือหุ้น",
    investorHome: "หน้าหลักนักลงทุนสัมพันธ์",
    shareholderInfo: "ข้อมูลผู้ถือหุ้น",
    selectYear: "เลือกปี",
    annualShareholdersMeeting: "การประชุมสามัญผู้ถือหุ้น",
    download: "ดาวน์โหลด",
    noData: "ไม่มีข้อมูลการประชุมสำหรับปีนี้",
    document: "เอกสาร",
    meetingYear: "ประจำปี",
    meetingNumber: "ครั้งที่",
  },
  financialInfoTabMenu: {
    importantFinancialInfo: 'ข้อมูลสำคัญทางการเงิน',
    financialStatements: 'งบการเงิน',
    managementDiscussion: 'คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ',
  },
  financialInfo: {
    pageTitle: 'ข้อมูลสำคัญทางการเงิน',
    breadcrumbHome: 'หน้าหลักนักลงทุนสัมพันธ์',
    breadcrumbFinancial: 'ข้อมูลทางการเงิน',

    total: 'รายได้',
    profit: 'กำไรสุทธิ',

    sectionTitle: 'ข้อมูลสำคัญทางการเงิน',
    unit: 'หน่วย: พันบาท',

    tableHeaders: {
      year: ['2565', '2566', '2567'],
      section1: 'ข้อมูลสำคัญทางการเงิน',
      totalAssets: 'สินทรัพย์รวม',
      totalLiabilities: 'หนี้สินรวม',
      equity: 'ส่วนของผู้ถือหุ้น (รวม)',
      salesRevenue: 'รายได้จากการขาย',
      totalRevenue: 'รายได้รวม',
      costOfSales: 'ต้นทุนขาย',
      totalExpenses: 'ค่าใช้จ่ายรวม',
      netProfit: 'กำไร/(ขาดทุน) สุทธิ (ส่วนที่เป็นของผู้ถือหุ้นของบริษัทฯ)',
    },

    section2Title: 'อัตราส่วนทางการเงินที่สำคัญ',
    ratios: {
      roe: 'อัตราผลตอบแทนผู้ถือหุ้น (ร้อยละ)',
      roa: 'อัตราผลตอบแทนจากสินทรัพย์ (ร้อยละ)',
      grossProfitMargin: 'อัตรากำไรขั้นต้น (ร้อยละ)',
      netProfitMargin: 'อัตรากำไรสุทธิ (ร้อยละ)',
      debtToEquity: 'อัตราส่วนหนี้สินต่อส่วนของผู้ถือหุ้น D/E (เท่า)',
      ibdToEquity: 'อัตราส่วนหนี้สินที่มีภาระดอกเบี้ยต่อส่วนของผู้ถือหุ้น IBD/E (เท่า)',
      assetTurnover: 'อัตราหมุนเวียนของสินทรัพย์รวม (เท่า)',
    },

    section3Title: 'ข้อมูลสถิติ',
    statistics: {
      registeredShares: 'จำนวนหุ้นจดทะเบียน (หุ้น)',
      parValue: 'ราคา Par (บาท)',
      marketCap: 'มูลค่าหลักทรัพย์ตามราคาตลาด (บาท)',
      bvps: 'Book Value per Share (บาท/หุ้น)',
      eps: 'EPS (บาท/หุ้น)',
      peRatio: 'P/E (เท่า)',
      pbvRatio: 'P/BV (เท่า)',
    }
  },
  stockPriceInfo: {
    pageTitle: 'ข้อมูลราคาหลักทรัพย์',
    breadcrumbHome: 'หน้าหลักนักลงทุนสัมพันธ์',
    breadcrumbCurrent: 'ข้อมูลราคาหลักทรัพย์',
    breadcrumbTitle: 'ราคาหลักทรัพย์',

    volume: 'ปริมาณซื้อขาย (หุ้น)',
    prior: 'วันก่อนหน้า',
    open: 'ราคาเปิด',
    change: 'เปลี่ยนแปลง (% เปลี่ยนแปลง)',
    updated: 'อัปเดตล่าสุด',
    offerVolume: 'ราคาเสนอขาย / ปริมาณซื้อขาย (หุ้น)',
    bidVolume: 'ราคาเสนอซื้อ / ปริมาณซื้อขาย (หุ้น)',
    dayRange: 'ช่วงราคาระหว่างวัน',
    currency: 'บาท',
  },
  shareSubscription: {
    pageTitle: "ORI - แจ้งสิทธิและรายละเอียดการจองซื้อหุ้นสามัญเพิ่มทุน",
    breadcrumb: [
      { text: "หน้าหลักนักลงทุนสัมพันธ์", to: "/" },
      { text: "ข้อมูลผู้ถือหุ้น" },
      { text: "ORI - แจ้งสิทธิและรายละเอียดการจองซื้อหุ้นสามัญเพิ่มทุน", isBold: true }
    ],
    tableTitle: "ข้อมูลเอกสาร",
    downloadText: "ดาวน์โหลด"
  },
  statements: {
    pageTitle: 'ข้อมูลสำคัญทางการเงิน',
    breadcrumbHome: 'หน้าหลักนักลงทุนสัมพันธ์',
    breadcrumbSection: 'ข้อมูลทางการเงิน',
    breadcrumbPage: 'งบการเงิน',
    download: 'ดาวน์โหลด',
    quarterLabel: 'ไตรมาส',
    selectYear: 'เลือกปี',
    document: 'เอกสาร',
    financialLabel: 'งบการเงิน',
    year: 'ปี'
  },
  description: {
    title: 'คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ',
    breadcrumbHome: 'หน้าหลักนักลงทุนสัมพันธ์',
    breadcrumbSection: 'ข้อมูลทางการเงิน',
    breadcrumbPage: 'คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ',
    labelYear: 'เลือกปี',
    latestLabel: 'คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ',
    quarterTitle: 'ไตรมาสที่',
    yearTitle: 'ปี',
    download: 'ดาวน์โหลด',
    tableTitle: 'การวิเคราะห์และคำอธิบายของฝ่ายจัดการไตรมาสที่',
    document: 'เอกสาร'
  },
  publishedDocsInfoTabMenu: {
    oneReport: 'แบบ 56-1 One Report',
    annualReport: 'รายงานประจำปี',
    sustainability: 'รายงานความยั่งยืน',
    form561: 'แบบฟอร์ม 56-1',
    // downloadDocs: 'ดาวน์โหลดเอกสารนักลงทุนสัมพันธ์'
  },
  oneReports: {
    pageTitle: 'แบบ 56-1 One Report',
    breadcrumbHome: 'หน้าหลักนักลงทุนสัมพันธ์',
    breadcrumbSection: 'เอกสารเผยแพร่',
    breadcrumbPage: 'แบบ 56-1 One Report',
    download: 'ดาวน์โหลด'
  },
  annualReport: {
    pageTitle: 'รายงานประจำปี',
    breadcrumbHome: 'หน้าหลักนักลงทุนสัมพันธ์',
    breadcrumbSection: 'เอกสารเผยแพร่',
    breadcrumbPage: 'รายงานประจำปี',
    download: 'ดาวน์โหลด'
  },
  debtInfoTabMenu: {
    bondInfo: 'ข้อมูลตราสารหนี้',
    creditRating: 'อันดับความน่าเชื่อถือ',
    billExchange: 'ข้อมูลผู้ค้าหลักทรัพย์ (ตั๋วแลกเงิน)'
  },
  debtInfo: {
    pageTitle: 'ข้อมูลตราสารหนี้',
    breadcrumbHome: 'หน้าหลักนักลงทุนสัมพันธ์',
    breadcrumbPage: 'ข้อมูลตราสารหนี้',
    table: {
      symbol: 'สัญลักษณ์',
      issuedSize: 'ขนาดที่ออก (ล้านบาท)',
      outstanding: 'ยอดคงค้าง (ล้านบาท)',
      issueDate: 'วันที่ออก',
      maturityDate: 'วันที่ครบกำหนด',
      term: 'อายุตราสาร',
      interestRate: 'อัตราดอกเบี้ย',
      total: 'รวม'
    }
  },
  billExchange: {
    title: 'ข้อมูลผู้ค้าหลักทรัพย์ (ตั๋วแลกเงิน)',
    menu: 'ข้อมูลตราสารหนี้',
    button: 'เข้าสู่เว็บไซต์',
    banks: {
      kkp: {
        name: 'ธนาคารเกียรตินาคินภัทร',
        address: 'เลขที่ 209 อาคารเคเคพี ทาวเวอร์ ถนนสุขุมวิท 21 (อโศก) ถนนสุขุมวิท แขวงคลองเตยเหนือ เขตวัฒนา กรุงเทพฯ 10110\nเบอร์โทรศัพท์ : 02-165-5555',
        url: 'https://bank.kkpfg.com/th/home'
      },
      scb: {
        name: 'ธนาคารไทยพาณิชย์ จำกัด (มหาชน)',
        address: 'เลขที่ 9 ถนนรัชดาภิเษก เขตจตุจักร กรุงเทพฯ 10330\nเบอร์โทรศัพท์ : 02-544-5740',
        url: 'https://www.scb.co.th/th/personal-banking/'
      },
      kbank: {
        name: 'ธนาคารกสิกรไทย จำกัด (มหาชน)',
        address: 'เลขที่ 400/22 ถ. พหลโยธิน แขวง สามเสนใน เขตพญาไท กรุงเทพมหานคร 10400\nเบอร์โทรศัพท์ : 02-273-3337'
      },
      yuanta: {
        name: 'บริษัทหลักทรัพย์หยวนต้า (ประเทศไทย) จำกัด',
        address: 'เลขที่ 127 อาคารเกษร ทาวเวอร์ ชั้น 14-16 ถนนราชดำริ แขวงลุมพินี เขตปทุมวัน กรุงเทพฯ 10330\nเบอร์โทรศัพท์ : 02-009-8889'
      }
    }
  },
  sustainabilityReport: {
    title: 'รายงานความยั่งยืน',
    home: 'หน้าหลักนักลงทุนสัมพันธ์',
    menu: 'เอกสารเผยแพร่',
    download: 'ดาวน์โหลด'
  },
  calendarInfo: {
    title: 'ปฏิทินนักลงทุนสัมพันธ์',
    breadcrumb: 'ปฏิทินนักลงทุนสัมพันธ์',
    home: 'หน้าหลักนักลงทุนสัมพันธ์',
    labelYear: 'เลือกปี',
    table: {
      date: 'วันที่',
      event: 'กิจกรรม',
      detail: 'รายละเอียด'
    },
    loading: 'กำลังโหลด...'
  },
  creditRating: {
    title: 'อันดับความน่าเชื่อถือ',
    breadcrumb: {
      home: 'หน้าหลักนักลงทุนสัมพันธ์',
      section: 'ข้อมูลตราสารหนี้',
      current: 'อันดับความน่าเชื่อถือ'
    },
    table: {
      date: 'วันที่',
      rating: 'อันดับเครดิตองค์กร',
      download: 'ดาวน์โหลด'
    }
  },
  analystInfoTabMenu: {
    contactAnalyst: 'ติดต่อนักวิเคราะห์',
    securitiesAnalysis: 'บทวิเคราะห์หลักทรัพย์',
  },
  analyst: {
    title: 'ติดต่อนักวิเคราะห์',
    breadcrumb: {
      home: 'หน้าหลักนักลงทุนสัมพันธ์',
      section: 'ข้อมูลนักวิเคราะห์',
      current: 'ติดต่อนักวิเคราะห์'
    },
    table: {
      company: 'บริษัทหลักทรัพย์',
      name: 'ชื่อนักวิเคราะห์',
      email: 'อีเมล'
    }
  },
  InformationTabMenu: {
    contactInvestorRelations: 'ติดต่อนักลงทุนสัมพันธ์',
    subscribeEmail: 'รับอีเมลข่าวสาร'
  },
  information: {
    title: "ติดต่อนักลงทุนสัมพันธ์",
    breadcrumbHome: "หน้าหลักนักลงทุนสัมพันธ์",
    breadcrumbInfo: "สอบถามข้อมูล",
    form: {
      heading: "ติดต่อนักลงทุนสัมพันธ์",
      phone: "โทรศัพท์",
      fax: "โทรสาร",
      email: "อีเมล",
      firstname: "ชื่อ",
      lastname: "นามสกุล",
      tel: "เบอร์โทรศัพท์",
      faxinput: "แฟกซ์",
      address: "ที่อยู่",
      details: "รายละเอียด",
      submit: "ส่งข้อความ",
      placeholder: {
        firstname: "กรอกชื่อ",
        lastname: "กรอกนามสกุล",
        tel: "ตัวอย่าง 088xxxxxxx",
        fax: "ตัวอย่าง 02xxxxxxx",
        details: "พิมพ์ข้อความของคุณที่นี่ !"
      },
      error: {
        firstname: "กรุณากรอกชื่อ",
        lastname: "กรุณากรอกนามสกุล",
        tel: "กรุณากรอกเบอร์โทรศัพท์ที่ถูกต้อง",
        fax: "กรุณากรอกแฟกซ์ที่ถูกต้อง",
        address: "กรุณากรอกที่อยู่",
        details: "กรุณากรอกรายละเอียด"
      },
      success: "ส่งข้อความสำเร็จแล้ว",
      fail: "มีปัญหาในการส่งข้อความ กรุณาลองใหม่อีกครั้ง",
      errorprocessing: "เกิดข้อผิดพลาดในการประมวลผลคำขอของคุณ กรุณาลองใหม่ในภายหลัง"
    }
  },
  receiveEmails: {
    home: "หน้าหลักนักลงทุนสัมพันธ์",
    placeholder: {
      fullName: "กรอกชื่อ-นามสกุล",
      email: "กรอกอีเมล",
      country: "เลือกประเทศ",
      occupation: "อาชีพ",
      jobTitle: "ตำแหน่งงาน",
      industry: "อุตสาหกรรม"
    },
    title: 'รับอีเมลข่าวสาร',
    breadcrumb: 'สอบถามข้อมูล',
    description1: 'ท่านสามารถลงทะเบียนเพื่อรับข่าวสารอิเล็กทรอนิกส์ เราจะส่งข่าวสารให้ท่านทาง อีเมล์',
    description2: 'เมื่อมีข่าวสารที่เกี่ยวกับบริษัท (ประกาศ, ปรับปรุงเว็บไซต์) ที่ประกาศผ่านเว็บไซต์นี้',
    description3: 'เพื่อลงทะเบียนรับข้อมูลข่าวสารอิเล็กทรอนิกส์กรุณากรอกรายละเอียด ของท่านและคลิกปุ่ม “สมัครสมาชิกรับข่าวสาร”',
    fullName: 'ชื่อและนามสกุล',
    email: 'อีเมล*',
    country: 'ประเทศ',
    occupation: 'อาชีพ',
    jobTitle: 'ตำแหน่งงาน',
    industry: 'อุตสาหกรรม',
    subscribe: 'สมัครรับข่าวสาร',
    unsubscribePrompt: 'หากท่านต้องการยกเลิกข่าวสารอิเล็กทรอนิกส์จาก บริษัท ออริจิ้น พร็อพเพอร์ตี้ จำกัด (มหาชน)',
    unsubscribeHere: 'โปรดคลิกที่นี่',
    modalTitle1: 'ยินดีต้อนรับเข้าสู่การบริการข่าวสารอิเล็กทรอนิกส์',
    modalTitle2: 'จากบริษัท ออริจิ้น พร็อพเพอร์ตี้ จำกัด (มหาชน)',
    modalInstruction: 'กรุณากรอกชื่ออีเมลของท่าน เพื่อยกเลิกการรับข้อมูลข่าวสารอิเล็กทรอนิกส์',
    unsubscribe: 'ยกเลิกรับข่าวสาร',
    close: 'ปิด',
    errorFullName: "กรุณากรอกชื่อ-นามสกุล",
    errorEmail: "กรุณากรอกอีเมลที่ถูกต้อง",
    errorCountry: "กรุณากรอกประเทศ",
    errorOccupation: "กรุณากรอกอาชีพ",
    errorJobTitle: "กรุณากรอกตำแหน่งงาน",
    errorIndustry: "กรุณากรอกอุตสาหกรรม",
    success: "คุณได้รับการสมัครรับข่าวสารเรียบร้อยแล้ว",
    fail: "มีปัญหาในการสมัครสมาชิก กรุณาลองใหม่อีกครั้ง",
    error: "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง",
    unsubSuccess: "คุณได้ยกเลิกการสมัครรับข่าวสารเรียบร้อยแล้ว",
    unsubFail: "มีปัญหาในการยกเลิก กรุณาลองใหม่อีกครั้ง"
  },
  activityInfo: {
    title: 'กิจกรรมและเอกสารนำเสนอ',
    breadcrumbHome: 'หน้าหลักนักลงทุนสัมพันธ์',
    breadcrumbCurrent: 'กิจกรรมและเอกสารนำเสนอ',
    yearLabel: 'เลือกปี',
    presentation: 'กิจกรรมนำเสนอ',
    download: 'ดาวน์โหลด'
  },
  newInfoTabMenu: {
    setNews: 'ข่าวแจ้งตลาดหลักทรัพย์',
    mediaNews: 'ข่าวแจ้งสื่อมวลชน',
    printNews: 'ข่าวจากสื่อสิ่งพิมพ์',
    electronicAds: 'โฆษณาทางอิเล็กทรอนิกส์'
  },
  newInfo: {
    title: 'ข่าวแจ้งตลาดหลักทรัพย์',
    home: 'หน้าหลักนักลงทุนสัมพันธ์',
    newsRoom: 'ห้องข่าว',
    readMore: 'อ่านเพิ่มเติม',
    search: 'ค้นหา',
    selectYear: 'เลือกปี',
    previous: 'ก่อนหน้า',
    next: 'ถัดไป',
  },
  newsMedia: {
    title: "ข่าวแจ้งสื่อมวลชน",
    home: "หน้าหลักนักลงทุนสัมพันธ์",
    newsRoom: "ห้องข่าว",
    search: "ค้นหา",
    selectYear: "เลือกปี",
    readMore: "อ่านเพิ่มเติม"
  },
  newsPrintMedia: {
    title: "ข่าวจากสื่อสิ่งพิมพ์",
    home: "หน้าหลักนักลงทุนสัมพันธ์",
    newsRoom: "ห้องข่าว",
    search: "ค้นหา",
    selectYear: "เลือกปี",
    readMore: "อ่านเพิ่มเติม",
    prev: "ย้อนกลับ",
    next: "ถัดไป"
  },
  electronicAdvertising: {
    title: "โฆษณาทางอิเล็กทรอนิกส์",
    home: "หน้าหลักนักลงทุนสัมพันธ์",
    newsRoom: "ห้องข่าว",
    search: "ค้นหา",
    selectYear: "เลือกปี",
    readMore: "อ่านเพิ่มเติม",
    prev: "ย้อนกลับ",
    next: "ถัดไป"
  },
  form56_1: {
    title: "แบบฟอร์ม 56-1",
    home: "หน้าหลักนักลงทุนสัมพันธ์",
    section: "เอกสารเผยแพร่",
    download: "ดาวน์โหลด",
    reportTitle: "แบบฟอร์ม 56-1 REPORT"
  },
  securitiesAnalysis: {
    title: "บทวิเคราะห์หลักทรัพย์",
    home: "หน้าหลักนักลงทุนสัมพันธ์",
    section: "ข้อมูลนักวิเคราะห์",
    selectYear: "เลือกปี",
    company: "บริษัทหลักทรัพย์",
    date: "วันที่",
    download: "ดาวน์โหลดไฟล์ PDF"
  }
}
